module.exports = __webpack_public_path__ + "static/media/logo-game-controller-b.17a42e12.svg";